export const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_7beaa497-9e3a-45b1-9ab5-409f8fb482c6/artifacts/76a2bc8172c72dd3_image.png";

const V = {
  a: "https://media.w3.org/2010/05/sintel/trailer.mp4",
  b: "https://media.w3.org/2010/05/bunny/trailer.mp4",
  c: "https://media.w3.org/2010/05/bunny/movie.mp4",
  d: "https://media.w3.org/2010/05/video/movie_300.mp4",
};

const T = {
  stage:
    "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBjb21tZXJjaWFsJTIwdmlkZW8lMjBzaG9vdGluZyUyMHByb2R1Y3Rpb24lMjBzdGFnZSUyMGRhcmslMjBsaWdodGluZ3xlbnwwfHx8fDE3OTMwMjkxODh8MA&ixlib=rb-4.1.0&q=85",
  talent:
    "https://images.unsplash.com/photo-1576280314550-773c50583407?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBjb21tZXJjaWFsJTIwdmlkZW8lMjBzaG9vdGluZyUyMHByb2R1Y3Rpb24lMjBzdGFnZSUyMGRhcmslMjBsaWdodGluZ3xlbnwwfHx8fDE3OTMwMjkxODh8MA&ixlib=rb-4.1.0&q=85",
  vertical:
    "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjBjb21tZXJjaWFsJTIwdmlkZW8lMjBzaG9vdGluZyUyMHByb2R1Y3Rpb24lMjBzdGFnZSUyMGRhcmslMjBsaWdodGluZ3xlbnwwfHx8fDE3OTMwMjkxODh8MA&ixlib=rb-4.1.0&q=85",
  backstage:
    "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBjb21tZXJjaWFsJTIwdmlkZW8lMjBzaG9vdGluZyUyMHByb2R1Y3Rpb24lMjBzdGFnZSUyMGRhcmslMjBsaWdodGluZ3xlbnwwfHx8fDE3OTMwMjkxODh8MA&ixlib=rb-4.1.0&q=85",
};

export const featured = [
  {
    id: "lays-mainstream",
    title: "Lay's — Ana Akım Kampanya",
    tag: "Mainstream",
    videoUrl: V.a,
    thumb: T.stage,
    ratio: "16/9",
    span: "lg:col-span-5",
  },
  {
    id: "cagan-ceren-talent",
    title: "Çağan & Ceren — Talent İş Birliği",
    tag: "Talent",
    videoUrl: V.b,
    thumb: T.talent,
    ratio: "16/9",
    span: "lg:col-span-4",
  },
  {
    id: "peugeot-vertical",
    title: "Peugeot — Dikey Dizi",
    tag: "Vertical Drama",
    videoUrl: V.c,
    thumb: T.vertical,
    ratio: "9/16",
    span: "lg:col-span-3",
  },
];

export const iWords = [
  { word: "Insight", font: "'Cormorant Garamond', serif", weight: 700, style: "italic", tracking: "0.08em" },
  { word: "Idea", font: "'Unbounded', sans-serif", weight: 900, style: "normal", tracking: "-0.04em" },
  { word: "Integrate", font: "'JetBrains Mono', monospace", weight: 700, style: "normal", tracking: "0.18em" },
  { word: "Influence", font: "'Bodoni Moda', serif", weight: 800, style: "normal", tracking: "0em" },
  { word: "Impact", font: "'Anton', sans-serif", weight: 400, style: "normal", tracking: "0.14em" },
  { word: "Inspire", font: "'Italiana', serif", weight: 400, style: "normal", tracking: "0.22em" },
];

export const categories = [
  {
    id: "tv-project",
    label: "TV Project",
    videos: [
      { id: "tv-1", title: "Prime Time Dizi — Marka Entegrasyonu", videoUrl: V.a, thumb: T.stage, ratio: "16/9" },
      { id: "tv-2", title: "Yarışma Programı — Ürün Evreni", videoUrl: V.d, thumb: T.backstage, ratio: "16/9" },
      { id: "tv-3", title: "Gündüz Kuşağı — Sponsorlu Segment", videoUrl: V.b, thumb: T.talent, ratio: "16/9" },
      { id: "tv-4", title: "Sezon Finali — Özel Yayın", videoUrl: V.c, thumb: T.vertical, ratio: "16/9" },
    ],
  },
  {
    id: "vertical-drama",
    label: "Vertical Drama",
    videos: [
      { id: "vd-1", title: "Peugeot — Dikey Dizi Serisi", videoUrl: V.c, thumb: T.vertical, ratio: "9/16" },
      { id: "vd-2", title: "Mikro Dizi — Bölüm 01", videoUrl: V.a, thumb: T.stage, ratio: "9/16" },
      { id: "vd-3", title: "Mikro Dizi — Bölüm 02", videoUrl: V.b, thumb: T.talent, ratio: "9/16" },
    ],
  },
  {
    id: "talent-brand",
    label: "Talent Brand",
    videos: [
      { id: "tb-1", title: "Çağan & Ceren — Marka Hikâyesi", videoUrl: V.b, thumb: T.talent, ratio: "16/9" },
      { id: "tb-2", title: "Influencer İş Birliği Filmi", videoUrl: V.d, thumb: T.backstage, ratio: "16/9" },
      { id: "tb-3", title: "Ünlü Lansman Hikâyesi", videoUrl: V.a, thumb: T.stage, ratio: "16/9" },
    ],
  },
  {
    id: "adv",
    label: "Adv",
    videos: [
      { id: "ad-1", title: "Lay's — Yaz Festivali", videoUrl: V.a, thumb: T.stage, ratio: "16/9" },
      { id: "ad-2", title: "TVC — 30sn Versiyon", videoUrl: V.c, thumb: T.vertical, ratio: "16/9" },
      { id: "ad-3", title: "Dijital Öncelikli Spot", videoUrl: V.b, thumb: T.talent, ratio: "16/9" },
      { id: "ad-4", title: "Açıkhava Motion Loop", videoUrl: V.d, thumb: T.backstage, ratio: "16/9" },
    ],
  },
  {
    id: "backstage",
    label: "Backstage",
    videos: [
      { id: "bs-1", title: "iCONTENT Set Hikâyeleri", videoUrl: V.d, thumb: T.backstage, ratio: "16/9" },
      { id: "bs-2", title: "Kamera Arkası — Festival Seti", videoUrl: V.a, thumb: T.stage, ratio: "16/9" },
      { id: "bs-3", title: "Casting Günlükleri", videoUrl: V.b, thumb: T.talent, ratio: "16/9" },
    ],
  },
];

export const scopeNodes = [
  { id: "matched", title: "Perfectly Matched", accent: "yellow" },
  { id: "creative", title: "Creative", accent: "blue" },
  { id: "balanced", title: "A Balanced Context", accent: "neutral" },
  { id: "fulladv", title: "Full Adver.", accent: "neutral" },
  { id: "reach", title: "Optimized Reach", accent: "neutral" },
  { id: "assessed", title: "Assessed at Every Step", accent: "neutral" },
];

export const team = [
  {
    id: "barbaros",
    name: "Barbaros Çıtmacı",
    role: "Founder / Managing Partner",
    photo:
      "https://images.unsplash.com/photo-1584940120505-117038d90b05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBzdHVkaW8lMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kJTIwcHJvZmVzc2lvbmFsJTIwbWFufGVufDB8fHx8MTc5MwMjkxODh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "esra",
    name: "Esra Apaydın",
    role: "Head of Content & Strategy",
    photo:
      "https://images.unsplash.com/photo-1788500657842-fcfbdc7331e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBzdHVkaW8lMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kJTIwcHJvZmVzc2lvbmFsJTIwd29tYW58ZW58MHx8fHwxNzkzMDI5MTg0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "yagmur",
    name: "Yağmur Koca",
    role: "Talent & Brand Director",
    photo:
      "https://images.unsplash.com/photo-1788500657759-6af4660f20eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBzdHVkaW8lMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kJTIwcHJvZmVzc2lvbmFsJTIwd29tYW58ZW58MHx8fHwxNzkzMDI5MTg0fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const contact = {
  address: "Maslak Mah. Büyükdere Cad. No:255, Sarıyer / İstanbul",
  phone: "+90 212 000 00 00",
  email: "merhaba@i-content.com.tr",
  socials: [
    { id: "instagram", label: "Instagram", href: "https://instagram.com" },
    { id: "linkedin", label: "LinkedIn", href: "https://linkedin.com" },
    { id: "youtube", label: "YouTube", href: "https://youtube.com" },
  ],
};

export const stats = [
  { value: "150+", label: "Branded Projects" },
  { value: "50M+", label: "Organic Reach" },
  { value: "25+", label: "Talent Collaborations" },
];
